<script>
export default {
  name: "IconWhiteMic"
};
</script>

<template>
  <svg width="16" height="24" viewBox="0 0 16 24" xmlns="http://www.w3.org/2000/svg">
    <g
      stroke="currentColor"
      stroke-width="2"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M8 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z" />
      <path d="M15 10v2a7 7 0 01-14 0v-2M8 19v4M4 23h8" />
    </g>
  </svg>
</template>
